import React, { useState, useEffect } from "react";
import ButtonLoader from "../../components/loader/ButtonLoader";
import { InputError } from "../../components/error/error";

const ResetPin = ({
  onClose,
  setShowSuccessModal,
  setShowConfirmPinPopup,
  onConfirm,
  setFormValues,
  formValues,
  isLoading,
}) => {
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (pin || confirmPin) {
      setError("");
    }
  }, [pin, confirmPin]);

  const handleConfirm = () => {
    if (!validateInputs()) {
      return;
    }
    onConfirm();
    setShowConfirmPinPopup(false);
  };

  const validateInputs = () => {
    if (pin.length !== 4) {
      setError("PIN must be exactly 4 digits.");
      return false;
    }
    if (pin !== confirmPin) {
      setError("PIN and Confirm PIN do not match.");
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    setPin("");
    setConfirmPin("");
    setError("");
    onClose();
    setShowSuccessModal(false);
  };

  return (
    <div className="model">
      <div className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-[391px] h-[302px] py-8 px-6 mx-auto relative">
        <h2 className="text-xl font-medium text-primaryBlack font-Montserrat mb-3 text-center">
          Enter new 4-digit Pin?
        </h2>
        <div className="flex flex-col gap-2">
          <input
            type="number"
            name="pin"
            maxLength="4"
            placeholder="4-digit Pin*"
            className={`border bg-white font-Proxima ${
              error ? "border-red" : "border-borderTheme/80"
            } px-4 py-2 rounded`}
            onChange={(e) => {
              setFormValues({
                id: formValues?.id,
                pin: e.target.value,
                confirmPin: formValues?.confirmPin,
              });
              setPin(e.target.value);
            }}
            value={pin}
            onFocus={(e) =>
              e.target.addEventListener(
                "wheel",
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              )
            }
          />
          <input
            type="number"
            name="confirmPin"
            maxLength="4"
            placeholder="Confirm new 4-digit Pin*"
            className={`border font-Proxima ${
              error ? "border-red" : "border-borderTheme/80"
            } px-4 py-2 rounded`}
            onChange={(e) => {
              setFormValues({
                id: formValues?.id,
                pin: formValues?.pin,
                confirmPin: e.target.value,
              });
              setConfirmPin(e.target.value);
            }}
            value={confirmPin}
            onFocus={(e) =>
              e.target.addEventListener(
                "wheel",
                function (e) {
                  e.preventDefault();
                },
                { passive: false }
              )
            }
          />
          {error && <InputError errorTitle={error} />}
          <div className="flex justify-end gap-3 pt-3">
            <button
              type="button"
              className="text-themeBtn text-[13px]  flex items-center uppercase font-Proxima justify-center px-6 py-1.5 rounded border border-themeBtn"
              onClick={handleCancel}
            >
              <span>Cancel</span>
            </button>
            <button
              type="button"
              className={`flex items-center text-[13px] justify-center px-6 py-1.5 rounded font-Proxima uppercase ${
                isLoading
                  ? "bg-disableThemeBtn"
                  : "border-2 border-themeBtn rounded text-white bg-themeBtn"
              }`}
              disabled={isLoading}
              onClick={handleConfirm}
            >
              {isLoading ? (
                <ButtonLoader removeTheme={true} />
              ) : (
                <span>Confirm</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPin;
